import type { AggregationLevel, EnergyTypes } from '~/types/new/energy';
import type { StandardError, StandardResponse, StandardTypes } from '../types';
import dayjs from 'dayjs';
import { Energy_Types_Enum } from '~/types/graphql/graphql';

export const standardStore = defineStore('standardStore', () => {
  // State
  const energyType = ref<EnergyTypes>('Electricity');
  const areaId = ref<number>(0);
  const period = ref<{ start: string; end: string; aggregationLevel: AggregationLevel }>({
    start: dayjs().subtract(1, 'month').format('YYYY-MM-DD HH:mm'),
    end: dayjs().startOf('day').format('YYYY-MM-DD HH:mm'),
    aggregationLevel: 'day',
  });
  const standardType = ref<StandardTypes>('weekly');
  const standardResponse = ref<StandardResponse | null>(null);
  const standardError = ref<StandardError | null>(null);
  const loading = ref<boolean>(true);

  // Getter
  const meterId = computed(() => {
    if (areaId.value == null) return undefined;
    const area = areaStore().getArea(areaId.value);
    return area?.meters.find((meter: any) => meter.meter_type.energy_type === energyType.value)?.id;
  });

  // ==================== Lifecycle ====================
  onBeforeMount(async () => {
    const area = areaStore().getAreas[0];
    if (area) {
      areaId.value = area.id;
      energyType.value = area.meters[0]?.meter_type.energy_type ?? Energy_Types_Enum.Electricity;
      period.value = {
        start: dayjs().subtract(1, 'month').format('YYYY-MM-DD HH:mm'),
        end: dayjs().startOf('day').format('YYYY-MM-DD HH:mm'),
        aggregationLevel: 'day',
      };
    }
  });

  return {
    // State
    energyType,
    areaId,
    period,
    standardType,
    standardResponse,
    standardError,
    loading,

    // Getter
    meterId,
  };
});
